/**
 * Tiny logger helper for swallowed-but-still-greppable errors.
 *
 * Why this exists:
 *   Many of our `try/catch` blocks intentionally swallow failures (private-mode
 *   localStorage, best-effort telemetry, fire-and-forget cleanup). Empty
 *   `catch {}` makes those impossible to debug in production.  We log at
 *   `console.debug` (filtered out of the default browser console, but visible
 *   when DevTools "Verbose" is enabled) and tag every entry so they're
 *   greppable.
 *
 *   Use `logger.warn(scope, err)` for things the user might care about (still
 *   shouldn't throw) and `logger.debug(scope, err)` for noise.
 */

function fmt(scope, err) {
  if (err && (err.stack || err.message)) {
    return [`[bp:${scope}]`, err.message || err, err.stack ? err.stack.split("\n")[1] : null].filter(Boolean);
  }
  return [`[bp:${scope}]`, err];
}

export const logger = {
  debug(scope, err) {
    // eslint-disable-next-line no-console
    console.debug(...fmt(scope, err));
  },
  warn(scope, err) {
    // eslint-disable-next-line no-console
    console.warn(...fmt(scope, err));
  },
  error(scope, err) {
    // eslint-disable-next-line no-console
    console.error(...fmt(scope, err));
  },
};
